import { render, staticRenderFns } from "./PagoProveedor.vue?vue&type=template&id=67a9b85f&scoped=true"
import script from "./PagoProveedor.vue?vue&type=script&lang=js"
export * from "./PagoProveedor.vue?vue&type=script&lang=js"
import style0 from "./PagoProveedor.vue?vue&type=style&index=0&id=67a9b85f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a9b85f",
  null
  
)

export default component.exports